export type QuickBooksEnvironment = {
  name: string;
  isProduction: boolean;
  description: string;
};

const environments: Record<string, QuickBooksEnvironment> = {
  development: {
    name: "Development",
    isProduction: false,
    description: "Local Development Environment",
  },
  staging: {
    name: "Staging",
    isProduction: false,
    description: "Staging Environment",
  },
  production: {
    name: "Production",
    isProduction: true,
    description: "Production Environment",
  },
};

export const getCurrentEnvironment = (): QuickBooksEnvironment => {
  const nodeEnv = process.env.NODE_ENV || "development";

  if (nodeEnv === "development") {
    return environments.development;
  } else if (nodeEnv === "staging") {
    return environments.staging;
  }
  return environments.production;
};

export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === "development";
};

export const isStaging = (): boolean => {
  return process.env.NODE_ENV === "staging";
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === "production";
};

export const getEnvironmentDisplay = (): string => {
  const env = getCurrentEnvironment();
  return env.isProduction ? "" : `(${env.name})`;
};
